var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWaveTriangle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.092 5.346a.514.514 0 0 1 .919-.089l.042.089 4.374 11.664 1.948-5.192a.514.514 0 0 1 .39-.325l.09-.008h4.047a.514.514 0 0 1 .092 1.019l-.092.008h-3.691l-2.302 6.141a.514.514 0 0 1-.92.088l-.042-.088L9.572 6.987 7.626 12.18a.514.514 0 0 1-.391.325l-.09.008H3.098a.514.514 0 0 1-.092-1.019l.092-.008h3.69l2.305-6.14Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWaveTriangle);
export default ForwardRef;